const getPathOffset = shape => ({
    x: shape.get('width') / 2,
    y: shape.get('height') / 2
});

export default getPathOffset;
